import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IContentMobile } from "../../../Pages/ContentMobile/IContentMobile";

export const EditContentMobileSlice = createSlice({
  name: "EditContentMobileSlice",
  initialState: {} as IReduxState<IContentMobile>,
  reducers: {
    EditContentMobile: (state, _: PayloadAction<IContentMobile>) => {
      state.isLoading = true;
    },
    successEditContentMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditContentMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditContentMobileResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  EditContentMobile,
  failureEditContentMobile,
  successEditContentMobile,
  clearEditContentMobileResponse,
} = EditContentMobileSlice.actions;

export default EditContentMobileSlice.reducer;
